import type { ColumnDef } from '@ovComponents/2-component/dataTable';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { ModelAggregation } from '../types';
import { getPhantomColumns } from '../utils/phantomColumns';

export function useModelColumns(): ColumnDef<ModelAggregation, unknown>[] {
  const { t } = useTranslation('portfolioTradingHub');

  return useMemo(
    (): ColumnDef<ModelAggregation, unknown>[] => [
      ...getPhantomColumns<ModelAggregation>({ withExpand: true }),
      {
        id: 'model',
        header: t('modelPortfolioView.columns.model'),
        accessorFn: (row) => row.modelName,
      },
      {
        id: 'portfolios',
        header: t('modelPortfolioView.columns.portfolios'),
        accessorFn: (row) => row.portfolioCount,
        meta: { dataTable: { align: 'center' } },
      },
      {
        id: 'marketValue',
        header: t('modelPortfolioView.columns.marketValue'),
        accessorFn: (row) => row.totalMarketValueCents,
        meta: { dataTable: { align: 'right', numeric: true } },
      },
      {
        id: 'avgDrift',
        header: t('modelPortfolioView.columns.avgDrift'),
        accessorFn: (row) => row.avgDriftPct,
        meta: { dataTable: { align: 'right', numeric: true } },
      },
      {
        id: 'rebalance',
        header: t('modelPortfolioView.columns.rebalance'),
        accessorFn: (row) => row.needsRebalanceCount,
        meta: { dataTable: { align: 'center' } },
      },
      {
        id: 'trades',
        header: t('modelPortfolioView.columns.trades'),
        accessorFn: (row) => row.pendingTradesCount,
        meta: { dataTable: { align: 'center' } },
      },
      {
        id: 'currency',
        header: t('modelPortfolioView.columns.currency'),
        accessorFn: (row) => row.currencies.join(', '),
        meta: { dataTable: { align: 'right' } },
      },
    ],
    [t],
  );
}
